import React from 'react';
export function Footer() {
  return <footer className="bg-ink py-12 px-4 border-t border-white/10" data-id="element-81">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-82">
        <h2 className="font-display text-3xl text-white mb-2 tracking-wider" data-id="element-83">
          SOCCER READY™
        </h2>
        <p className="text-gray-500 text-sm mb-8" data-id="element-84">
          © 2025 Soccer Ready™. All Rights Reserved.
        </p>

        <div className="flex gap-6 text-sm text-gray-400 mb-8" data-id="element-85">
          <a href="#" className="hover:text-white transition-colors" data-id="element-86">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-87">
            Terms & Conditions
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-88">
            Contact Us
          </a>
        </div>

        <p className="text-xs text-gray-600 max-w-md" data-id="element-89">
          Soccer Ready™ is a digital product. Results may vary based on
          implementation and individual coaching circumstances.
        </p>
      </div>
    </footer>;
}